<template>
  <div id="noon-form-time-picker">
    <vs-row vs-w="12">
      <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
        <div class="block">
          <div class="aisea-text-14-400-gray">{{ form.label }}</div>
          <vue-timepicker v-model="time" :format="form.format" :disabled="isUndecided"
                          :placeholder="blank"
                          :hide-clear-button="true" hour-label="時" minute-label="分"
                          second-label="秒"></vue-timepicker>
        </div>
        <vs-checkbox v-model="isUndecided" :color="AISEA_COLOR.BLUE" class="mt-6 pl-12"><span>未定</span></vs-checkbox>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import "flatpickr/dist/flatpickr.css";
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

import {DeviceInfoMixin, ColorMixin} from "@/mixins";

export default {
  mixins: [DeviceInfoMixin, ColorMixin],

  props: {
    form: {type: Object, required: true},
    value: {required: false}
  },

  components: {
    VueTimepicker
  },

  data () {
    return {
      time: null,
      isUndecided: false,
      blank: " "
    }
  },

  watch: {
    time: {
      handler(val) {
        const payload = {
          id: this.form.id,
          label: this.time,
          value: this.time,
          isAlert: false
        };
        this.$emit("setValue", payload)
      },
    },

    isUndecided(val) {
      let payload
      if (val) {
        payload = {
          id: this.form.id,
          label: "",
          value: "",
          isAlert: false
        };
      } else {
        if (this.time) {
          payload = {
            id: this.form.id,
            label: this.time,
            value: this.time,
            isAlert: false
          };
        } else {
          this.time = this.concatTime()
          return
        }
      }
      this.$emit("setValue", payload)
    }
  },
  computed: {
  },
  methods: {
    concatTime() {
      let time = ""
      this.form.format.split(":").forEach(v => {
        if (v === "h" || v === "H") {
          time = "0:"
        }

        if (v === "hh" || v === "HH") {
          time = "00:"
        }

        if (v === "m") {
          time = `${time}0:`
        }

        if (v === "mm") {
          time = `${time}00:`
        }

        if (v === "s") {
          time = `${time}0`
        }

        if (v === "ss") {
          time = `${time}00`
        }
      })
      return time
    },
  },
  mounted () {
    if (this.value) {
      this.time = this.value;
    } else if (this.form.default_value) {
      this.time = this.form.default_value
    } else {
      //this.time = this.concatTime();
      this.isUndecided = true;
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/vessel-noon-report.scss";

#noon-form-time-picker {
  --vs-primary: 3, 155, 229;

  .vue__time-picker input.display-time {
    padding: 0.8rem !important;
    border-radius: 5px;
    height: 49px;
    font-size: 1.2em;
    color: #626262;
  }

  .vue__time-picker .dropdown ul li:not([disabled]).active {
    background: $aisea-blue;
  }

  input:focus {
    border: 1px solid $aisea-blue !important;
  }
}
</style>
